// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
// Translate Module
import { TranslateModule } from '@ngx-translate/core';
//Froala Module
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
// UI
import { PartialsModule } from 'app/views/partials/partials.module';
// Auth
import { ModuleGuard } from 'app/core/auth';
// Core => Utils
import { HttpUtilsService,
	TypesUtilsService,
	InterceptService,
	LayoutUtilsService
} from 'app/core/_base/crud';

import { NgxPermissionsModule } from 'ngx-permissions';
import { NgbProgressbarModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

//Share
import { ActionNotificationComponent } from 'app/views/partials/content/crud';
import { DeleteEntityDialogComponent } from 'app/views/partials/content/crud';
import { FetchEntityDialogComponent } from 'app/views/partials/content/crud';
import { UpdateStatusDialogComponent } from 'app/views/partials/content/crud';
import { AlertComponent } from 'app/views/partials/content/crud';



//Component
import { ChonDeNghiTamUngComponent } from './chon-de-nghi-tam-ung.component';
import { ChonDeNghiTamUngListComponent } from './chon-de-nghi-tam-ung-list/chon-de-nghi-tam-ung-list.component';

//Service
import { ChonDeNghiTamUngService } from './chon-de-nghi-tam-ung-service/chon-de-nghi-tam-ung.service';

//Moment Module
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { PopoverModule } from 'ngx-smart-popover';

import { NFCModule } from 'app/views/pages/nfc/NFC.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
//Datepicker Format
import { MY_FORMATS_EDIT } from 'app/views/pages/nfc/datepicker';
import { DynamicSearchFormModule } from 'app/views/pages/components/dynamic-search-form/dynamic-search-form.module';
import { DynamicSearchFormService } from 'app/views/pages/components/dynamic-search-form/dynamic-search-form.service';
// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
	MatChipsModule,
	MAT_DATE_LOCALE,
	DateAdapter,
	MAT_DATE_FORMATS
} from '@angular/material';



@NgModule({
    imports: [
        NgbModule,
		MatDialogModule,
		CommonModule,
		HttpClientModule,
		PartialsModule,
		NgxPermissionsModule.forChild(),
		NgxMatSelectSearchModule,
		
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
        MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		NgbProgressbarModule,
		FroalaEditorModule.forRoot(),
		FroalaViewModule.forRoot(),
		MatChipsModule,
		DragDropModule,
		ScrollingModule,
		CdkTableModule,
		CdkTreeModule,
		PopoverModule,
		NFCModule,
		
		PerfectScrollbarModule,
		DynamicSearchFormModule,
		
	],
	providers: [
		ModuleGuard,
		InterceptService,
      	{
        	provide: HTTP_INTERCEPTORS,
       	 	useClass: InterceptService,
        	multi: true
      	},
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				panelClass: 'kt-mat-dialog-container__wrapper',
				height: 'auto',
				width: '900px'
			}
		},
		{ provide: MAT_DATE_LOCALE, useValue: 'vi' },
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_EDIT },
		TypesUtilsService,
		LayoutUtilsService,
		HttpUtilsService,
		ChonDeNghiTamUngService
	],
	entryComponents: [
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		UpdateStatusDialogComponent,
		FetchEntityDialogComponent,
		AlertComponent,
		ChonDeNghiTamUngListComponent
	],
	declarations: [
		ChonDeNghiTamUngComponent,
		ChonDeNghiTamUngListComponent,
		
	]
})
export class ChonDeNghiTamUngModule {}
